import {Tab, TabList, TabPanel, Tabs} from 'react-tabs'
import ButtonClose from '../../../../../../components/UI/Button/IconButton'
import {useHoteleria} from '../../../../../../hooks/useHoteleria'
import {TabModel} from '../../../../../../models'
import {FC} from 'react'
import {TableReportFacturationSubDetailWrapper} from '../Tables/TableReportFacturationSubDetail'

const DetailReportSubPanel: FC = () => {
  const {currentTabItem, changeCurrentTabItem} = useHoteleria()
  const handleBack = () => {
    const obj: TabModel = {
      ...currentTabItem,
      showPanel: false,
    }
    changeCurrentTabItem(obj)
  }
  let isDisabled = currentTabItem.idToEdit ? true : false
  return (
    <>
      <div className='sdx_content_tab_panel'>
        {isDisabled && <ButtonClose onClick={handleBack} color='#283897' />}
        <Tabs className={'sdx_sub_react_tab_panel '}>
          <TabList className={'sdx_sub_tab_panel p-0'}>
            <Tab className={'sdx_sub_tab_panel_option'}>Tabla de Facturación</Tab>
          </TabList>
          <TabPanel>
            <TableReportFacturationSubDetailWrapper />
          </TabPanel>
        </Tabs>
      </div>
    </>
  )
}

export {DetailReportSubPanel}
